import { signalOrgNodesInputChanged } from "../../../../common/webpack/shared/const/dependingOnOrgNodesConstants";

document.addEventListener("DOMContentLoaded", () => {
  const occupationClassesDependingOnOrgNodes = document.querySelectorAll(".occupation_class_depending_on_org_nodes");
  if (!occupationClassesDependingOnOrgNodes.length) {
    return;
  }
  const helpText = document.getElementById("hint_id_occupation_class");
  if (!helpText) {
    return;
  }
  helpText.style.display = "none";
  document.querySelectorAll("[id='id_org_nodes']").forEach((el) => {
    el.addEventListener(signalOrgNodesInputChanged, (e) => {
      // only show occupation help text when org nodes have been chosen
      helpText.style.display = e.detail ? "block" : "none";
    });
  });
});
